import { Component, Input } from '@angular/core';
import {StatusPropostaFiltro} from "../../../aplicacao/enum/status-parceiro-filtro.enum";
import { StatusProposta } from 'src/app/aplicacao/enum/status-proposta.enum';

@Component({
  selector: 'app-badge-status',
  templateUrl: './badge-status.component.html',
  styleUrls: ['./badge-status.component.scss']
})
export class BadgeStatusComponent {
  @Input() status = "";


  getStatusText(){
    switch(this.status){
      case StatusPropostaFiltro.Documentacao :
        return "Documentação";
      case StatusPropostaFiltro.Negociacao :
        return "Negociação";
      case StatusPropostaFiltro.PropostaVencida :
        return "Proposta Vencida";
      case StatusPropostaFiltro.EmAndamento :
        return "Em Andamento";
      case StatusProposta.Aprovada :
        return "Pagas";
      case StatusProposta.Reprovada :
        return "Reprovadas";
      default:
        return this.status;
    }
  }

  getStatusColor(){
    switch(this.status){
      case StatusPropostaFiltro.Documentacao :
        return "bg-orange";
      case StatusPropostaFiltro.Negociacao :
        return "bg-orange";
      case StatusPropostaFiltro.PropostaVencida :
        return "bg-cinza-noite";
      case StatusPropostaFiltro.EmAndamento :
        return "bg-warning";
      case StatusProposta.Aprovada :
      case StatusProposta.Pago :
        return "bg-success text-white";
      case StatusProposta.Reprovada :
        return "bg-cinza-noite text-white";
      default:
        return "bg-cinza-noite text-white";
    }
  }

  protected readonly StatusPropostaFiltro = StatusPropostaFiltro;
}
